import { Controller } from "@hotwired/stimulus"

// Generic show/hide disclosure. The server sets the initial state via
// data-collapse-expanded-value (e.g. the wizard's "Refine which posts to
// boost" section starts collapsed, but opens when a recommendation has
// pre-scoped a post type or a condition is already set). The header toggles it.
export default class extends Controller {
  static targets = ["body", "chevron"]
  static values = { expanded: { type: Boolean, default: false } }

  connect() {
    console.log("[collapse] connect expanded=", this.expandedValue)
    this.#apply()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    console.log("[collapse] toggle ->", this.expandedValue)
    this.#apply()
  }

  #apply() {
    if (this.hasBodyTarget) this.bodyTarget.classList.toggle("hidden", !this.expandedValue)
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-180", this.expandedValue)
  }
}
